import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TokenResponse')
export default class TokenResponse {
  @JsonProperty('access_token')
  public accessToken: string = '';
  @JsonProperty('token_type')
  public tokenType: string = '';
  @JsonProperty('refresh_token')
  public refreshToken: string = '';
  @JsonProperty('expires_in')
  public expiresIn: number = -1;
  @JsonProperty('id_token')
  public idToken: string = '';
}
